 <template>
  <div
    :class="[
      'twoPage',
      'clearfix',
      pageTwoAction ? 'animated pageFadeIn' : 'pageFadeOut',
    ]"
  >
    <div
      :class="['twoIconPng', twoTitShow ? 'imgAnimated imgFadeIn' : 'bgGray']"
    ></div>
    <div class="bottom"></div>
    <!-- 白底 + 边框  文字-->
    <div :class="['titHeader', 'twoAnimated', 'fadeInUpBig']" v-if="twoTitShow">
      开启生态战略，我们在路上 <span class="circle circleOne"></span>
      <span class="circle"></span>
    </div>
    <div class="fl titBox">
      <p class="textMian animated delay fadeIn" v-if="twoTitShow">
        2016年05月，我院邀请国家级领导、省内外林业专家，组织召开“2016生态规划战略研讨会”，详细剖析了生态行业未来发展规划，明确了我院发展方向和行业定位。
      </p>
    </div>
    <div class="bwBox" v-if="twoBtnShow" @click="changeHue">
      <div class="wave wave4"></div>
      <div class="wave wave3"></div>
      <div class="wave wave1"></div>
      <div class="wave waveOne">
        <!-- <img :src="baseUrl + 'img/dhShare/dianTwo.png'" class="textAmation" /> -->
        <img :src="baseUrl + 'img/dhShare/dianIcon.png'" class="textAmation" />
      </div>
    </div>
    <div :class="['imgMainBox', twoTitShow ? 'imgMainBoxShow' : '']">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperChild">
        <swiper-slide
          class="slideItem"
          v-for="(item, index) in slideList"
          :key="index"
        >
          <van-image
            fit="cover"
            @click="seeImg(item, index)"
            :src="baseUrl + item.imgUrl"
          />
        </swiper-slide>
      </swiper>
    </div>

    <van-overlay @click="bigImgShow = false" class="tkMain" :show="bigImgShow">
      <div class="wrapper">
        <van-image
          fit="cover"
          :src="baseUrl + bigImgUrl + '?x-oss-process=image/resize,p_50'"
        />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import "@/assets/style/animate.min.less";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@/assets/style/animate.min.less";
export default {
  name: "twoPage",
  props: {
    landscapeType: {
      type: Boolean,
      default: false,
    },
    newIndex: {
      type: String,
    },
  },
  components: {
    swiper,
    swiperSlide,
  },

  data() {
    return {
      baseUrl: process.env.BASE_URL,
      typePage: false,
      twoTitShow: false,
      pageTwoAction: false,
      twoBtnShow: true,
      bigImgShow: false,
      swiperOption: {
        loop: false,
        slidesPerView: 3, //数量
        spaceBetween: 15, //间距
        initialSlide: 1,
        centeredSlides: true,
        direction: "horizontal", //设置水平horizontal还是垂直vertical
      },
      bigImgUrl: "",
      slideList: [
        {
          imgUrl: "img/dhShare/twoK002.jpg",
        },
        {
          imgUrl: "img/dhShare/twoK001.jpg",
        },
        {
          imgUrl: "img/dhShare/twoK003.jpg",
        },
        {
          imgUrl: "img/dhShare/twoK004.jpg",
        },
        {
          imgUrl: "img/dhShare/twoK005.jpg",
        },
        {
          imgUrl: "img/dhShare/twoK006.jpg",
        },
        {
          imgUrl: "img/dhShare/twoK007.jpg",
        },
        {
          imgUrl: "img/dhShare/twoK008.jpg",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.typePage = this.landscapeType;
      this.initPage();
    });
  },
  methods: {
    initPage() {
      this.pageTwoAction = true;
    },

    changeHue() {
      this.twoBtnShow = false;
      this.twoTitShow = true;
    },
    seeImg(item) {
      this.bigImgShow = true;
      this.bigImgUrl = item.imgUrl;
    },
  },
  watch: {
    landscapeType: function (newVal) {
      this.typePage = newVal;
    },
    newIndex: function (newValue) {
      if (newValue == "1") {
        this.pageTwoAction = true;
      } else {
        this.pageTwoAction = false;
      }
    },
  },
};
</script>
<style lang="less">
.twoPage {
  width: 100%;
  height: 100%;
  background-image: url("../../../../../public/img/dhShare/slideTwo.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  position: relative;
  .twoIconPng {
    width: 100%;
    height: 100%;
    background-image: url("../../../../../public/img/dhShare/twoIcon.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: relative;
    z-index: 3;
    -webkit-filter: grayscale(100%);
    /* Chrome, Safari, Opera */
    filter: grayscale(100%);
  }
  .bottom {
    z-index: 9;
    width: 100%;
    height: 100%;
    background-image: url("../../../../../public/img/dhShare/bottomTwo.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .titHeader {
    top: 105px;
    right: -55px;
    border: 1px solid #2f882a;
    color: #2f882a;
    .circle {
      border: 1px solid #2f882a;
    }
  }
  .titBox {
    position: absolute;
    top: 90px;
    right: 3px;
    // .tit {
    //   width: 240px;
    //   position: absolute;
    //   top: 20px;
    //   left: -150px;
    //   font-size: 16px;
    //   color: #8e3f08;
    //   font-weight: 600;
    // }
    .textMian {
      position: absolute;
      top: 65px;
      left: -60px;
      width: 200px;
      font-size: 12px;
      color: #2f882a;
      text-align: justify;
      opacity: 0;
    }
  }

  /** css3动画效果 **/
  @-webkit-keyframes fadeInRightBig {
    0% {
      opacity: 0;
      -webkit-transform: translateX(1000px) rotate(90deg);
      -ms-transform: translateX(1000px) rotate(90deg);
      transform: translateX(1000px) rotate(90deg);
    }

    50% {
      opacity: 0.2;
      -webkit-transform: translateX(-30px) rotate(90deg);
      -ms-transform: translateX(-30px) rotate(90deg);
      transform: translateX(-30px) rotate(90deg);
    }
    85% {
      opacity: 0.5;
      -webkit-transform: translateX(10px) rotate(90deg);
      -ms-transform: translateX(10px) rotate(90deg);
      transform: translateX(10px) rotate(90deg);
    }
    100% {
      opacity: 1;
      -webkit-transform: translateX(0) rotate(90deg);
      -ms-transform: translateX(0) rotate(90deg);
      transform: translateX(0) rotate(90deg);
    }
  }

  @keyframes fadeInRightBig {
    0% {
      opacity: 0;
      -webkit-transform: translateX(1000px) rotate(90deg);
      -ms-transform: translateX(1000px) rotate(90deg);
      transform: translateX(1000px) rotate(90deg);
    }

    50% {
      opacity: 0.2;
      -webkit-transform: translateX(-30px) rotate(90deg);
      -ms-transform: translateX(-30px) rotate(90deg);
      transform: translateX(-30px) rotate(90deg);
    }
    85% {
      opacity: 0.5;
      -webkit-transform: translateX(10px) rotate(90deg);
      -ms-transform: translateX(10px) rotate(90deg);
      transform: translateX(10px) rotate(90deg);
    }
    100% {
      opacity: 1;
      -webkit-transform: translateX(0) rotate(90deg);
      -ms-transform: translateX(0) rotate(90deg);
      transform: translateX(0) rotate(90deg);
    }
  }

  .fadeInUpBig {
    -webkit-animation-name: fadeInRightBig;
    animation-name: fadeInRightBig;
  }
  .twoAnimated {
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
  }

  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
  .textMian {
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
  }
  .imgMainBox {
    display: none;
    position: absolute;
    bottom: 25px;
    left: 0;
    // -webkit-transform: rotate(90deg);
    // transform: rotate(90deg);
    z-index: 999;
    width: 100%;

    .swiperChild.swiper-container {
      width: 320px;
      height: 120px;
      .swiper-wrapper {
        margin-top: 15px;
        .slideItem.swiper-slide {
          width: 110px;
          height: 95px;
          background-color: #fff;
          z-index: 1000;
          border-radius: 10px;
          -webkit-border-radius: 10px;
          padding: 5px 5px;
          opacity: 0.7;
          .van-image {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            img {
              border-radius: 8px;
            }
          }
        }
        .slideItem.swiper-slide.swiper-slide-active {
          transform: scale(1.2);
          opacity: 1;
        }
      }
    }
  }
  .tkMain.van-overlay {
    position: absolute !important;
    width: 100% !important;
    height: 75% !important;
    left: 0;
    top: 0;
    z-index: 9999;
    background-color: rgba(225, 225, 225, 0);
    overflow: hidden;

    .wrapper {
      position: absolute;
      width: 320px;
      height: 450px;
      background-color: #fff;
      padding: 5px 5px;
      left: 50%;
      top: 50%;
      margin-left: -155px;
      margin-top: -210px;
      border-radius: 10px;
      -webkit-border-radius: 10px;
    }

    .van-image {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      img {
        border-radius: 8px;
      }
    }
  }
  .imgMainBox.imgMainBoxShow {
    display: block;
  }
}
</style>